<script>
  export let darkerLineEvery = 5
  export let height
  export let width
  export let xDim = 100
  export let xStart
  export let yDim = 100
  export let yStart

  function generateAxisLines({ axisDim, axisSize, axisStart }) {
    const lines = []

    for (let i = 0; i < axisDim; i++) {
      const isDarker = i % darkerLineEvery == 0

      const stepRatio = i / parseFloat(axisDim)
      const offset = axisStart + stepRatio * axisSize

      const line = { offset, stroke: isDarker ? "black" : "#ccc" }

      lines.push(line)
    }

    return lines
  }

  $: xLines = generateAxisLines({ axisDim: xDim, axisSize: width, axisStart: xStart })
  $: yLines = generateAxisLines({ axisDim: yDim, axisSize: height, axisStart: yStart })
</script>

<g>
  <g>
    {#each xLines as xLine}
      <line
        x1={xLine.offset}
        x2={xLine.offset}
        y1={yStart}
        y2={yStart + height}
        stroke={xLine.stroke}
      />
    {/each}
  </g>

  <g>
    {#each yLines as yLine}
      <line
        x1={xStart}
        x2={xStart + width}
        y1={yLine.offset}
        y2={yLine.offset}
        stroke={yLine.stroke}
      />
    {/each}
  </g>
</g>
